import React from 'react'
import {Drawer, Space, Button, Flex, Tag, Card, Divider, App} from "antd";
import {SettingOutlined, NumberOutlined, ArrowLeftOutlined, FileImageOutlined} from "@ant-design/icons";
import {Form, useDynamicForm} from "kaiju.core";
import i18n from "i18next";
import {usePlugin} from "src/Plugins";


const AttributeKinds: any[] = [
    {
        kind: "string",
        label: "attribute-kind.string",
        icon: <Tag className={"attr-kind-icon"} color={"magenta"}><SettingOutlined/></Tag>,
        description: "attribute-kind.description.string"
    },
    {
        kind: "text",
        label: "attribute-kind.text",
        icon: <Tag className={"attr-kind-icon"} color={"green"}><SettingOutlined/></Tag>
    },
    {
        kind: "integer",
        label: "attribute-kind.integer",
        icon: <Tag className={"attr-kind-icon"} color={"cyan"}><NumberOutlined/></Tag>
    },
    {
        kind: "decimal",
        label: "attribute-kind.decimal",
        icon: <Tag className={"attr-kind-icon"} color={"gold"}><SettingOutlined/></Tag>
    },
    {
        kind: "boolean",
        label: "attribute-kind.boolean",
        icon: <Tag className={"attr-kind-icon"} color={"purple"}><SettingOutlined/></Tag>
    },
    {
        kind: "collection_select",
        label: "attribute-kind.collection_select",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "collection_multiselect",
        label: "attribute-kind.collection_multiselect",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "json_object",
        label: "attribute-kind.json_object",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "select",
        label: "attribute-kind.select",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "multiselect",
        label: "attribute-kind.multiselect",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "date",
        label: "attribute-kind.date",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "datetime",
        label: "attribute-kind.datetime",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "dynamic_zone",
        label: "attribute-kind.dynamic_zone",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "media",
        label: "attribute-kind.media",
        icon: <Tag className={"attr-kind-icon"} color={"purple"}><FileImageOutlined/></Tag>
    },
    {
        kind: "string_list",
        label: "attribute-kind.string_list",
        icon: <Tag className={"attr-kind-icon"} color={"purple"}><SettingOutlined/></Tag>
    },
    {
        kind: "tag",
        label: "attribute-kind.tag",
        icon: <Tag className={"attr-kind-icon"} color={"purple"}><SettingOutlined/></Tag>
    },
    {
        kind: "component",
        label: "attribute-kind.component",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "component_list",
        label: "attribute-kind.component_list",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },
    {
        kind: "component_any",
        label: "attribute-kind.component_any",
        icon: <Tag className={"attr-kind-icon"} color={"blue"}><SettingOutlined/></Tag>
    },

]

const AttrForm: React.FC<{ appId?: string, kind: string, collectionId: string, onClose: any }> = ({
                                                                                                   appId,
                                                                                                   kind,
                                                                                                   collectionId,
                                                                                                   onClose
                                                                                               }) => {
    const {notification} = App.useApp();
    const [store] = useDynamicForm({
        autoLoad: true,
        loadRequest: {
            method: 'ContentTypeBuilder.collection.attribute.model',
            params: {
                kind: kind
            }
        },
        isNested: true,
        saveDiff: false,
        loadExtraParams: {
            application: appId,
            collection: collectionId,
        },
        saveRequest: {
            method: 'ContentTypeBuilder.collection.attribute.create',
            params: {
                collection: collectionId,
                kind: kind
            }
        },
        successCallback: (response: any) => {
            notification.success({
                message: i18n.t('message.attribute-success-create'),
                placement: 'topRight',
            });
            onClose()
        }
    });
    return <Form store={store.formStore}>
        <Space>
            <Button onClick={() => {
                store.submit()
            }} type="primary">
                {i18n.t("common.add")}
            </Button>
        </Space>
    </Form>
}


const CreateAttribute: React.FC<{ appId?: string, onClose: any, open: boolean, collectionId?: string }> = ({
                                                                                                            appId,
                                                                                                            collectionId,
                                                                                                            open,
                                                                                                            onClose
                                                                                                        }) => {
    const {state} = usePlugin({
        id: collectionId,
        state: {
            "collection.attribute.kinds": React.useMemo(()=>[...AttributeKinds], [])
        },
        commonData: {
            appId,
            collectionId,
        }
    })

    const [currentKind, setKind] = React.useState<string>("")

    const handleClose = () => {
        onClose()
        setKind("")
    }
    return <>
        <Drawer
            title={
                <>
                    <span>{i18n.t("attribute.create-new")}</span>
                </>}
            onClose={handleClose}
            width={900}
            open={open}
            size={"large"}
        >
            <div className={"attr-create-body"}>
                {currentKind.length === 0 &&
                    <>
                        <h3>{i18n.t("attribute-kind.choice")}</h3>
                        <Card>
                            {state["collection.attribute.kinds"].map((val: any) => {
                                return <Card.Grid key={'card-item-' + val.label} className={"attr-kind-grid"} onClick={() => {
                                    setKind(val.kind)
                                }}>
                                    <Flex>
                                        <div>{val.icon}</div>
                                        <div>
                                            <div className={"fw-500"}>{i18n.t(val.label)}</div>
                                            <div
                                                className={"description"}>{val.description ? i18n.t(val.description) : ""}</div>
                                        </div>
                                    </Flex>
                                </Card.Grid>
                            })}
                        </Card>
                    </>
                }
                {(currentKind.length > 1 && collectionId) &&
                    <>
                        <div style={{marginBottom: "2rem"}}><a onClick={() => {
                            setKind((""))
                        }}><ArrowLeftOutlined/> {i18n.t("common.back")}</a></div>
                        {state["collection.attribute.kinds"].filter((val: any) => (val.kind === currentKind)).map((val: any) => {
                            return (<Flex>
                                <div>{val.icon}</div>
                                <div>
                                    <h3 className={"fw-500"}
                                        style={{margin: 0, paddingBottom: 5}}>{i18n.t(val.label)}</h3>
                                    <div
                                        className={"description"}>{val.description ? i18n.t(val.description) : ""}</div>
                                </div>
                            </Flex>)
                        })}
                        <Divider/>
                        <AttrForm kind={currentKind} collectionId={collectionId} appId={appId} onClose={handleClose}/>
                    </>
                }
            </div>
        </Drawer>
    </>
}

export {CreateAttribute}